import { useTranslation } from "react-i18next";
import { faDistributeSpacingVertical } from "@fortawesome/pro-regular-svg-icons";
import { IWebsiteBuilderNodeMetadata } from "../nodeMetadata/websiteBuilderNodeMetadata";

export function useWebsiteBuilderGridCellMetadata(): IWebsiteBuilderNodeMetadata {
  const { t } = useTranslation();

  return {
    title: t("Cell"),
    icon: faDistributeSpacingVertical,
  };
}